import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from 'environments/environment';
import { of } from 'rxjs';
import { catchError, map } from 'rxjs/operators';
import { RouteConfig } from '@shared/components/shared.model';

@Injectable({ providedIn: 'root' })
export class NavigationConfigService {

  constructor(private http: HttpClient) { }

  /**
   * Fetches navigation config for the given platform (blank = default/main).
   * Stores the result in localStorage as 'route-config', overriding any
   * previously cached value.
   *
   * Platform values will be filled in once BE naming is finalised;
   * passing an empty string fetches the default (main) config.
   */
  fetchAndStore(platform: string = ''): Promise<void> {
    const rootUrl = platform === 'accounting' ? environment.accountingModuleRootApiUrl : (platform === 'bhs' ? environment.bhsModuleRootUrl : environment.rootUrl);

    const url = rootUrl + environment.urls.nav_config;
    const params = platform ? { platform } : {};

    return this.http.get<RouteConfig>(url, { params })
      .pipe(
        map(routeConfig => {
          localStorage.setItem(
            environment.storage.routeConfig,
            JSON.stringify(routeConfig)
          );
          localStorage.setItem(environment.storage.routeConfigPlatform, platform);
        }),
        catchError(err => {
          console.error('NavigationConfigService: failed to fetch nav config', err);
          return of(undefined);
        })
      )
      .toPromise();
  }
}
